import styled, { css } from 'styled-components';

import { BackgroundSection } from '@xing-com/crate-layout-background-section';
import { Container } from '@xing-com/layout-primitives';
import {
  mediaConfined,
  mediaTopBarVisible,
  mediaTopBarHidden,
  mediaTiny,
} from '@xing-com/layout-tokens';
import { spaceM, spaceXL, spaceL, spaceXXL } from '@xing-com/tokens';

import prideBackground1080 from './assets/pride-brackground.jpg';

export const Background = styled(BackgroundSection)<{
  $showPrideBanner: boolean;
}>`
  padding: 0;

  ${({ $showPrideBanner }) =>
    $showPrideBanner &&
    css`
      background-image: url(${prideBackground1080});
      background-size: 110% 100%;

      @media ${mediaTiny} {
        background-image: url(${prideBackground1080});
      }
    `}
`;

export const SearchBarContainer = styled(Container)<{ $isLoggedOut?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${spaceM};

  @media ${mediaTopBarHidden} {
    padding-block: ${spaceXL};
  }

  ${({ $isLoggedOut }) =>
    $isLoggedOut &&
    css`
      @media ${mediaTopBarVisible} {
        padding-top: ${spaceL};
      }
    `}
`;

export const ContentContainer = styled(Container)`
  display: block;
  margin-top: ${spaceXL};
  padding: 0 20px;

  @media ${mediaConfined} {
    padding: 0 ${spaceXXL};
  }

  @media ${mediaTopBarHidden} {
    display: grid;
    gap: ${spaceXXL};

    /* grid-template-columns: minmax(270px, 400px) minmax(600px, 800px); Previous, check with Silke */
    grid-template-columns: minmax(270px, calc(400 / 1256 * 100%)) minmax(
        300px,
        65.6%
      );
  }
`;

export const LeftColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spaceXXL};
  margin-right: ${spaceXXL};
  order: -1;

  @media ${mediaTopBarVisible} {
    display: none;
  }
`;
